/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UnitColumns {
    FLOORPLAN_NAME = 'floorplan_name',
    BED = 'bed',
    BATH = 'bath',
    PARTIAL_BATH = 'partial_bath',
    FLOOR = 'floor',
    SQFT = 'sqft',
    DAYS_ON_MARKET = 'days_on_market',
    UNIT_ID = 'unit_id',
}
